import { handleAjaxError } from "../actions/handleAjaxError";
import { updateCredits } from "../actions/updateCredits";

function imageWrapperIconImgToVideo(element) {
  $(element)
    .find(".icon-imgtovideo")
    .click(function (event) {
      event.preventDefault();
      event.stopPropagation();

      const button = $(this);
      const imageWrapper = button.closest(".image-wrapper");
      const imageId = imageWrapper.attr("data-image-id");
      const imageUrl = imageWrapper.attr("href");

      // Prevent double click
      if (button.hasClass("is-loading")) return;

      button.addClass("is-loading");

      let labelTimeout;
      const infoLabel = $(
        '<span class="info-label">Generating... Please wait.</span>'
      );

      // Show label after 2s if still loading
      labelTimeout = setTimeout(() => {
        if (
          button.hasClass("is-loading") &&
          button.find(".info-label").length === 0
        ) {
          button.append(infoLabel);
        }
      }, 2000);

      // ── Step 1: Initiate generation ──
      jQuery.ajax({
        url: growtype_chat_ajax.url,
        type: "post",
        data: {
          image_id: imageId,
          image_url: imageUrl,
          action: growtype_chat_ajax.convert_image_to_video,
          nonce: growtype_chat_ajax.nonce,
        },
        success: function (response) {
          const data = response.data;
          const assets = data.assets;

          // Case 1: Already completed (cached video exists)
          if (
            data.status === "completed" ||
            (Array.isArray(assets) && assets.length > 0)
          ) {
            handleCompleted(button, data, labelTimeout);
            return;
          }

          // Case 2: Async — assets is { status: "processing", generation_id: "..." }
          if (
            assets &&
            assets.status === "processing" &&
            assets.generation_id
          ) {
            startPolling(
              button,
              imageWrapper,
              assets.generation_id,
              labelTimeout
            );
            return;
          }

          // Case 3: assets is inline { status: "completed", video_urls: [...] }
          if (assets && assets.status === "completed") {
            handleCompleted(button, assets, labelTimeout);
            return;
          }

          // Fallback: no recognizable response
          clearTimeout(labelTimeout);
          button.find(".info-label").remove();
          button.removeClass("is-loading");
          console.error("[ImgToVideo] Unexpected response format:", response);
        },
        error: function (response) {
          clearTimeout(labelTimeout);
          button.find(".info-label").remove();
          button.removeClass("is-loading");
          handleAjaxError(response);
        },
      });
    });
}

/**
 * Handle completed generation — open video in fancybox.
 */
function handleCompleted(button, data, labelTimeout) {
  clearTimeout(labelTimeout);
  button.find(".info-label").remove();
  button.removeClass("is-loading");

  const videoUrls = data.video_urls || data.assets || [];
  const items = videoUrls.map((video) => ({
    src: video.url,
    type: "video",
    opts: {
      animationEffect: "zoom",
    },
  }));

  if (items.length > 0) {
    $.fancybox.open(items);
  }

  if (data.existing_credits !== undefined) {
    updateCredits(data.existing_credits);
  }
}

/**
 * Poll the API until the video generation is complete.
 */
// sessionStorage key prefix for pending generation state
const PENDING_GEN_KEY = "growtype_chat_pending_gen_";

/**
 * Store pending generation state so polling can survive a page reload.
 */
function storePendingGen(generationId, imageWrapper, attempts, startTime) {
  try {
    const imageId = imageWrapper.attr("data-image-id");
    const imageUrl = imageWrapper.attr("href");
    sessionStorage.setItem(
      PENDING_GEN_KEY + generationId,
      JSON.stringify({
        generationId,
        imageId,
        imageUrl,
        attempts,
        startTime,
      })
    );
  } catch (e) {
    // sessionStorage may be unavailable
  }
}

/**
 * Remove pending generation state once resolved.
 */
function clearPendingGen(generationId) {
  try {
    sessionStorage.removeItem(PENDING_GEN_KEY + generationId);
  } catch (e) {
    // sessionStorage may be unavailable
  }
}

/**
 * On page load (or bfcache restore), check for pending generations and resume polling.
 * Retries DOM lookups for up to 5s to handle dynamically-loaded content.
 */
function resumePendingGenerations(retryCount) {
  if (!sessionStorageAvailable()) return;

  retryCount = retryCount || 0;
  const now = Date.now();
  const maxTotalMs = 10 * 60 * 1000; // 10 minutes total
  let foundPending = false;

  for (let i = 0; i < sessionStorage.length; i++) {
    const key = sessionStorage.key(i);
    if (!key || !key.startsWith(PENDING_GEN_KEY)) continue;

    foundPending = true;

    try {
      const data = JSON.parse(sessionStorage.getItem(key));
      const elapsed = now - (data.startTime || now);

      // If past 10 minutes total, clean up and don't resume
      if (elapsed >= maxTotalMs) {
        clearPendingGen(data.generationId);
        continue;
      }

      // Find matching image wrapper in DOM
      const imageWrapper = $(
        '.image-wrapper[data-image-id="' + data.imageId + '"]'
      ).first();

      if (imageWrapper.length === 0) {
        // Image wrapper not in DOM yet — retry up to 10 times (5s total)
        if (retryCount < 10) {
          setTimeout(function () {
            resumePendingGenerations(retryCount + 1);
          }, 500);
        } else {
          // Gave up after 5s — clean up stale entry
          clearPendingGen(data.generationId);
        }
        continue;
      }

      const button = imageWrapper.find(".icon-imgtovideo");
      if (button.length === 0) continue;

      // Resume polling with stored state
      button.addClass("is-loading");

      const infoLabel = $(
        '<span class="info-label">Generating... Please wait.</span>'
      );
      button.append(infoLabel);

      resumePolling(
        button,
        imageWrapper,
        data.generationId,
        null, // no labelTimeout on resume
        data.attempts || 0,
        data.startTime
      );
    } catch (e) {
      clearPendingGen(key ? key.slice(PENDING_GEN_KEY.length) : "");
    }
  }

  // If no pending entries at all and we were retrying, stop retrying
  if (!foundPending && retryCount > 0) {
    return;
  }
}

function sessionStorageAvailable() {
  try {
    const test = "__test__";
    sessionStorage.setItem(test, test);
    sessionStorage.removeItem(test);
    return true;
  } catch (e) {
    return false;
  }
}

function startPolling(button, imageWrapper, generationId, labelTimeout) {
  const startTime = Date.now();

  storePendingGen(generationId, imageWrapper, 0, startTime);

  resumePolling(button, imageWrapper, generationId, labelTimeout, 0, startTime);
}

/**
 * The actual polling loop, shared by startPolling and resumePendingGenerations.
 */
function resumePolling(
  button,
  imageWrapper,
  generationId,
  labelTimeout,
  initialAttempts,
  startTime
) {
  const maxAttempts = 120; // 10 minutes at 5s intervals
  let attempts = initialAttempts;
  let pollTimer;

  const infoLabel = button.find(".info-label");
  if (infoLabel.length === 0) {
    button.append(
      $('<span class="info-label">Generating... Please wait.</span>')
    );
  }

  function updateLabel(text) {
    const label = button.find(".info-label");
    if (label.length) {
      label.text(text);
    }
  }

  function poll() {
    attempts++;

    // Also enforce a hard 10-minute wall-clock timeout
    const elapsed = Date.now() - startTime;
    if (attempts > maxAttempts || elapsed >= 10 * 60 * 1000) {
      clearTimeout(pollTimer);
      clearPendingGen(generationId);
      button.find(".info-label").remove();
      button.removeClass("is-loading");
      handleAjaxError({
        responseJSON: {
          data: { message: "Video generation timed out. Please try again." },
        },
      });
      return;
    }

    const percent = Math.min(99, Math.round((attempts / maxAttempts) * 100));
    updateLabel("Generating... " + percent + "%");

    // Persist current progress so a reload can pick up from here
    storePendingGen(generationId, imageWrapper, attempts, startTime);

    jQuery.ajax({
      url: growtype_chat_ajax.url,
      type: "post",
      data: {
        generation_id: generationId,
        action: growtype_chat_ajax.check_generation_status,
        nonce: growtype_chat_ajax.nonce,
      },
      success: function (response) {
        if (!response.success) {
          clearTimeout(pollTimer);
          clearPendingGen(generationId);
          button.find(".info-label").remove();
          button.removeClass("is-loading");
          handleAjaxError({ responseJSON: response });
          return;
        }

        const status = response.data;
        const statusValue = status.status || "processing";

        if (statusValue === "completed" || statusValue === "succeeded") {
          clearTimeout(pollTimer);
          clearPendingGen(generationId);
          if (labelTimeout) clearTimeout(labelTimeout);
          button.find(".info-label").remove();
          button.removeClass("is-loading");

          const videoUrls = status.video_urls || [];
          const items = videoUrls.map((video) => ({
            src: video.url,
            type: "video",
            opts: {
              animationEffect: "zoom",
            },
          }));

          if (items.length > 0) {
            $.fancybox.open(items);
          }

          if (status.existing_credits !== undefined) {
            updateCredits(status.existing_credits);
          }
        } else if (statusValue === "failed" || statusValue === "error") {
          clearTimeout(pollTimer);
          clearPendingGen(generationId);
          if (labelTimeout) clearTimeout(labelTimeout);
          button.find(".info-label").remove();
          button.removeClass("is-loading");
          handleAjaxError({
            responseJSON: {
              data: {
                message:
                  status.error || "Video generation failed. Please try again.",
              },
            },
          });
        } else {
          // Still processing — poll again
          pollTimer = setTimeout(poll, 5000);
        }
      },
      error: function (response) {
        clearTimeout(pollTimer);
        clearPendingGen(generationId);
        if (labelTimeout) clearTimeout(labelTimeout);
        button.find(".info-label").remove();
        button.removeClass("is-loading");
        handleAjaxError(response);
      },
    });
  }

  // Start polling after initial delay
  pollTimer = setTimeout(poll, 5000);
}

// Resume pending generations on initial page load
$(function () {
  resumePendingGenerations(0);
});

// Also resume when the page is restored from back/forward cache
$(window).on("pageshow", function (event) {
  if (event.originalEvent && event.originalEvent.persisted) {
    resumePendingGenerations(0);
  }
});

export { imageWrapperIconImgToVideo };
